const baseState = {
    action: '',
    product: null,
}

export default function reducer(state = baseState, action) {
    switch (action.type) {
        case 'ADD_TO_CART':
            return {
                ...state,
                action: 'add',
                product: action.payload,
            }
        case 'REMOVE_FROM_CART':
            return {
                ...state,
                action: 'remove',
                product: action.payload,
            }
        case 'UPDATE_CART_QUANTITY':
            return {
                ...state,
                action: 'update',
                product: action.payload.product,
            }
        case 'RESET_CART_NOTIFICATION':
        case 'TOGGLE_CART':
        case '@@router/LOCATION_CHANGE':
        case 'USER_LOGOUT':
            return { ...baseState }
        default:
            return state
    }
}
